/**
 * Form categories (= form types). The values are used as:
 * - `category` value on form definitions and form instances (seeds and database),
 * - `:category` URL segment in the frontend (`/forms/instances/<category>`).
 */
export enum FormCategory {
  MarketAggregatedData = 'marketAggregatedData',
  ManualMarketData = 'manualMarketData',
  VansManualMarketData = 'vansManualMarketData',
}

// Default export needed because of an error in the frontend (see `form-instance-status.enum.ts`).
export default FormCategory;
